import { useShowcase } from '@/hooks/use-showcase';
import { useSurvey } from '@/hooks/use-survey';
import { FEATURE_FLAGS, useFeatureFlag } from '@/lib/feature-flags';
import { useEffect } from 'react';

const KEY = 'q3-roadmap-survey';
const SURVEY_NAME = 'q3-roadmap';
const ONE_DAY = 24 * 60 * 60 * 1000;

// show the Q3 roadmap survey once a day until the user submits it, then never again.
export function Q3RoadmapSurvey() {
  const enabled = useFeatureFlag(FEATURE_FLAGS.Q3_ROADMAP_SURVEY);
  const { shouldShow, complete } = useShowcase(KEY);
  const survey = useSurvey(SURVEY_NAME, { throttle: ONE_DAY, onSent: complete });

  useEffect(() => {
    if (enabled && shouldShow && survey.available) survey.open();
  }, [enabled, shouldShow, survey.available, survey.open]);

  return null;
}
